export const UNPAID_INVOICES_LOADED = 'UNPAID_INVOICES_LOADED'; // eslint-disable-line
export const TRIALS_LOADED = 'TRIALS_LOADED';
